import _extends from '@babel/runtime/helpers/extends';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default, { forwardRef } from 'react';
import './Checkbox.scss.js';
import { classnames } from '../../../utils/classnames.js';
import AllReduce from '../../../assets/icons/resultDir/AllReduce.js';
import AllSuccess from '../../../assets/icons/resultDir/AllSuccess.js';

var Checkbox = /*#__PURE__*/forwardRef(function (_a, ref) {
  var label = _a.label,
      labelClassName = _a.labelClassName,
      value = _a.value,
      _a$icon = _a.icon,
      icon = _a$icon === void 0 ? true : _a$icon,
      _a$align = _a.align,
      align = _a$align === void 0 ? 'flex-start' : _a$align,
      _a$halfChecked = _a.halfChecked,
      halfChecked = _a$halfChecked === void 0 ? false : _a$halfChecked,
      _a$position = _a.position,
      position = _a$position === void 0 ? 'left' : _a$position,
      _a$round = _a.round,
      round = _a$round === void 0 ? false : _a$round,
      _a$fullWidth = _a.fullWidth,
      fullWidth = _a$fullWidth === void 0 ? false : _a$fullWidth,
      _a$titleAtt = _a.titleAtt,
      titleAtt = _a$titleAtt === void 0 ? '' : _a$titleAtt,
      style = _a.style,
      props = __rest(_a, ["label", "labelClassName", "value", "icon", "align", "halfChecked", "position", "round", "fullWidth", "titleAtt", "style"]);

  var roundClass = round ? 'rf-checkbox__check--round' : '';
  var fullWidthClass = fullWidth ? 'rf-checkbox__check--fullWidth' : '';
  var disabledClass = props.disabled ? 'disabled' : '';
  var alignClass = {
    'flex-start': 'rf-checkbox--flex-start',
    'center': 'rf-checkbox--center',
    'flex-end': 'rf-checkbox--flex-end'
  };
  var showIconClass = icon ? '' : 'rf-checkbox__label--no-icon';
  var positionClass = position === 'left' ? 'rf-checkbox--left' : 'rf-checkbox--right';
  return /*#__PURE__*/React__default.createElement("label", {
    ref: ref,
    className: "rf-checkbox ".concat(props.className || '', " ").concat(disabledClass, " ").concat(alignClass[align], " ").concat(positionClass, " ").concat(fullWidthClass),
    style: style,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("input", _extends({}, props, {
    type: "checkbox",
    className: "rf-checkbox__input ".concat(halfChecked ? 'rf-checkbox__input--half-checked' : ''),
    value: value,
    "data-v-6e52f9c7": ""
  })), !!icon && /*#__PURE__*/React__default.createElement("span", {
    className: "rf-checkbox__check ".concat(roundClass),
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "rf-checkbox__mark",
    "data-v-6e52f9c7": ""
  }, halfChecked ? /*#__PURE__*/React__default.createElement(AllReduce, {
    "data-v-6e52f9c7": ""
  }) : /*#__PURE__*/React__default.createElement(AllSuccess, {
    "data-v-6e52f9c7": ""
  }))), label && /*#__PURE__*/React__default.createElement("div", {
    title: titleAtt,
    className: classnames('rf-checkbox__label', showIconClass, labelClassName),
    tabIndex: -1,
    "data-v-6e52f9c7": ""
  }, label));
});

export { Checkbox as default };
